// extracted by mini-css-extract-plugin
export default {"msgM":"_4ee56e7f89"};